export const SETDISPLAY = 'SETDISPLAY'

interface SetDisplay {
  type: typeof SETDISPLAY
  payload: {
    n: string
  }
}

export const setDisplay = (n: string): SetDisplay => ({
  type: SETDISPLAY,
  payload: {
    n,
  },
})

export type countActionTypes = SetDisplay
